import OfflineOrderRule from './OfflineOrder.rule';
import { OfflineOrderRulesTo } from './OfflineOrderRules.types';
import PreOrderMinimumAmountByItemRule from './orderProduct/rules/preOrderMinimumAmountByItem.rule';
import PreOrderMinimumAmountByProductRule from './orderProduct/rules/preOrderMinimumAmountByProduct.rule';
import PreOrderMultipleAmountByItemRule from './orderProduct/rules/preOrderMultipleAmountByItem.rule';
import PreOrderMultipleAmountByProductRule from './orderProduct/rules/preOrderMultipleAmountByProduct.rule';
import ReadyForDeliveryMinimumAmountByItemRule from './orderProduct/rules/readyForDeliveryMinimumAmountByItem.rule';
import ReadyForDeliveryMinimumAmountByProductRule from './orderProduct/rules/readyForDeliveryMinimumAmountByProduct.rule';
import ReadyForDeliveryMultipleAmountByItemRule from './orderProduct/rules/readyForDeliveryMultipleAmountByItem.rule';
import ReadyForDeliveryMultipleAmountByProductRule from './orderProduct/rules/readyForDeliveryMultipleAmountByProduct.rule';

export default class OfflineOrderRulesFactory {
  private readonly creators: {
    [K in OfflineOrderRulesTo]: () => OfflineOrderRule<K>[];
  } = {
    [OfflineOrderRulesTo.VALIDATE_GENERAL_DATA]: () => this.createForValidateGeneralData(),
    [OfflineOrderRulesTo.VALIDATE_PRODUCTS]: () => this.createForValidateProducts(),
    [OfflineOrderRulesTo.VALIDATE_CONDITIONS]: () => this.createForValidateConditions(),
  };

  create<T extends OfflineOrderRulesTo>({ useRulesTo }: { useRulesTo: T }): OfflineOrderRule<T>[] {
    return this.creators[useRulesTo]();
  }

  private createForValidateGeneralData(): OfflineOrderRule<OfflineOrderRulesTo.VALIDATE_GENERAL_DATA>[] {
    return [];
  }

  private createForValidateProducts(): OfflineOrderRule<OfflineOrderRulesTo.VALIDATE_PRODUCTS>[] {
    return [
      new PreOrderMinimumAmountByItemRule(),
      new PreOrderMinimumAmountByProductRule(),
      new PreOrderMultipleAmountByItemRule(),
      new PreOrderMultipleAmountByProductRule(),
      new ReadyForDeliveryMinimumAmountByItemRule(),
      new ReadyForDeliveryMinimumAmountByProductRule(),
      new ReadyForDeliveryMultipleAmountByItemRule(),
      new ReadyForDeliveryMultipleAmountByProductRule(),
    ];
  }

  private createForValidateConditions(): OfflineOrderRule<OfflineOrderRulesTo.VALIDATE_CONDITIONS>[] {
    return [];
  }
}
